import $ from 'jquery';
import { Modal } from 'bootstrap';
import AppEvents from './app-events';
import Form from './form';
import ds from './ds';

import 'Shared/util';
//require('Shared/util');

 class ModalApi {
     constructor(id = 'dynamic-modal-container', options = {}) {
        this.id = id;

        let defaults = {
            beforeSubmit: this.#beforeSubmit,
            submit: this.#submit,
            afterSubmit: this.#afterSubmit
        };

        this.options = defaults.merge(options);

        this.#bindEvents();
    }

    #container = () => document.getElementById(this.id);
    #modal = () => Modal.getOrCreateInstance(this.#container(), this.options);

    #deferred = null;

    #bindEvents = () => {
        var container = this.#container();

        container.addEventListener("show.bs.modal", (e) => AppEvents.emit(ModalApi.Events.MODAL_SHOW, self));
        container.addEventListener("shown.bs.modal", (e) => AppEvents.emit(ModalApi.Events.MODAL_SHOWN, self));
        container.addEventListener("hide.bs.modal", (e) => {

            if (this.#deferred && this.#deferred.state() === 'pending') {
                this.#deferred.resolve(false);
            }

            AppEvents.emit(ModalApi.Events.MODAL_HIDE, self)
        });
        container.addEventListener("hidden.bs.modal", (e) => {
            AppEvents.emit(ModalApi.Events.MODAL_HIDDEN, self)

            let container = this.#container();
            let elContent = container.querySelector(".modal-content");
            ko.cleanNode(container);
            elContent.innerHTML = '';
        });

        container.addEventListener('submit', (e) => {
            e.preventDefault();

            this.submit(e.target);
        });
    }

    #beforeSubmit = form => Promise.resolve(true);
    #submit = async form => await Form.submitAjax(form);
    #afterSubmit = (form, result) => Promise.resolve(true);

    submit = async (form) => {
        if (await this.options.beforeSubmit(form)) {
            try {
                let result = await this.options.submit(form);
                if (result && result.Success) {
                    if (await this.options.afterSubmit(form, result)) {

                        if (this.#deferred) {
                            this.#deferred.resolve(result, form);
                        }

                        this.hide();
                    }
                }
            }
            catch (e) {
                console.error(e);
                this.#deferred.resolve(false);
            }
        }
    }

    open = async (content, model = vm, bind = true) => 
    {
        let container = this.#container();
        
        if (content) {
            let frag = document.createRange().createContextualFragment(content);
            let elContent = container.querySelector(".modal-content");

            ko.cleanNode(container);
            elContent.innerHTML = '';
            elContent.appendChild(frag);

            if (bind) {
                if (model instanceof Function) {
                    const m = await model();

                    ko.applyBindings(m, elContent);
                }
                else
                    ko.applyBindings(model, elContent);
            }
        }

        this.show();

        this.#deferred = $.Deferred();
        return this.#deferred;
    }

    load = async (url, data, model, bind) => {
        var content = await ds.get(url, data);
        return this.open(content, model, bind);
    }

    show = () => this.#modal().show();
    hide = () => this.#modal().hide();

    static Events = {
        MODAL_SHOW: "modal.show",
        MODAL_SHOWN: "modal.shown",
        MODAL_HIDE: "modal.hide",
        MODAL_HIDDEN: "modal.hidden"
    };
}

export default new ModalApi();